import { CatHeading } from '@blocks-react/components/Heading';
import { PartsDiagramDescriptionProps } from '../types';

export const PartsDiagramDescription = ({
  children,
  classname
}: PartsDiagramDescriptionProps) => {
  return (
    <div className={classname}>
      <CatHeading variant="footnote">{children}</CatHeading>
    </div>
  );
};
